import { Oauth2ServiceTypes } from 'cw-isdk/api-interface';
import { SsoDataResponseObject } from 'cw-isdk/core';
import { Observable } from 'rxjs';
import { Service } from 'typedi';
import { ApiService } from './api.service';

@Service()
export class OAuth2Service {

    private readonly _apiService: ApiService;
    private readonly _area = 'General';
    private readonly _controller = 'Oauth2';
    public constructor(
        apiService: ApiService
    ) {
        this._apiService = apiService;
    }

    public tidTokenUser(request: Oauth2ServiceTypes.Requests.TidTokenUser): Observable<SsoDataResponseObject> {
        return this._apiService.post<Oauth2ServiceTypes.Requests.TidTokenUser, SsoDataResponseObject>('coreResponseValue', {
            action: 'TidTokenUser',
            area: this._area,
            data: request,
            service: this._controller,
        });
    }

    public updateTidTokenUser(oidcUserBytes: string): Observable<boolean> {
        return this._apiService.post('coreResponseValue', {
            action: 'UpdateTidTokenUser',
            area: this._area,
            data: {
                TidTokenUser: oidcUserBytes
            },
            service: this._controller,
        });
    }
}